type Miliseconds = number
export const wait = (ms: Miliseconds): Promise<Miliseconds> =>
    new Promise(res => setTimeout(() => res(ms), ms))
